import { render, staticRenderFns } from "./ListTabs.vue?vue&type=template&id=d4df7ba2&scoped=true"
import script from "./ListTabs.vue?vue&type=script&lang=ts"
export * from "./ListTabs.vue?vue&type=script&lang=ts"
import style0 from "./ListTabs.vue?vue&type=style&index=0&id=d4df7ba2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4df7ba2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4df7ba2')) {
      api.createRecord('d4df7ba2', component.options)
    } else {
      api.reload('d4df7ba2', component.options)
    }
    module.hot.accept("./ListTabs.vue?vue&type=template&id=d4df7ba2&scoped=true", function () {
      api.rerender('d4df7ba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/v2/ListTabs.vue"
export default component.exports